export default "__VITE_ASSET__UvD23WFwbRsl9Qin79zTzw__"